module.exports = __webpack_public_path__ + "static/media/FD3.89f90fc7.jpg";